import React from 'react'
import { ButtonCommonTopNew } from '../../pages/Theme'

const ModalCreateShowcase = ({ handleClose,
    show,
    onChange,
    onClick,
    showcaseName,
    showcaseNameEmpty,
    showcaseNameExist,
    showcaseLoader,
    inputDisabled,
    buttonDisabled
}) => {

    const showHideModal = show
        ? 'fixed top-0 left-0 w-full h-full bg-black bg-opacity-60 block modelIndex'
        : 'fixed top-0 left-0 w-full h-full bg-black bg-opacity-60 hidden'

    const handleKeypress = e => {
        //it triggers by pressing the enter key
        if (e.key === 'Enter') {
            e.preventDefault()
            onClick()
        }
    };

    return (
        <div className={showHideModal} >
            <div className="fixed inset-0 modelIndex flex items-center justify-center bg-black bg-opacity-50 px-4 py-6">
                <div className={`relative cardBackgroundColor rounded-xl shadow-md p-4 max-w-full max-h-screen overflow-auto top-2 bottom-2 right-2 left-2 modal-popup-width`}>
                    <div className="flex gap-2 items-center justify-between">
                        <p className="font-semibold blackColor">Create New Showcase</p>
                        <button
                            onClick={handleClose}
                            className="text-gray-600 hover:text-black text-xl font-bold"
                        >&times;
                        </button>
                    </div>
                    <form className="flex flex-col py-3 space-y-5">
                        <div className="flex flex-row py-2">
                            <label className="mr-2 md:mr-8 font-semibold md:py-3 md:whitespace-nowrap text-sm blackColor">Showcase Name</label>
                            <input
                                className="border border-gray-300 px-5 py-3 rounded-lg w-full"
                                type="text"
                                placeholder="type here..."
                                value={showcaseName}
                                onChange={onChange}
                                disabled={inputDisabled}
                                onKeyPress={handleKeypress}
                            />
                        </div>
                    </form>
                    {showcaseNameEmpty === true &&
                        <span className="cover-file-show-error text-xs">Please enter the showcase name</span>
                    }
                    {showcaseNameExist === true &&
                        <span className="cover-file-show-error text-xs">Showcase name already exist</span>
                    }
                    <div className="flex justify-center">
                        <ButtonCommonTopNew className={`px-5 border p-2 text-sm rounded-lg ${showcaseLoader ? "pointer-events-none" : "cursor-pointer"} `} onClick={onClick} disabled={buttonDisabled}>
                            Create
                        </ButtonCommonTopNew>
                    </div>

                </div>
            </div>
        </div>
    )
}

export default ModalCreateShowcase